interface SteelLinkLogoProps {
  variant?: 'dark' | 'light';
  size?: 'sm' | 'md' | 'lg';
}

export default function SteelLinkLogo({ variant = 'dark', size = 'md' }: SteelLinkLogoProps) {
  const sizes = {
    sm: { icon: 'text-lg', steel: 'text-lg', link: 'text-lg', global: 'text-[9px]', gap: 'gap-2', iconBox: 'w-8 h-8' },
    md: { icon: 'text-2xl', steel: 'text-2xl', link: 'text-2xl', global: 'text-[11px]', gap: 'gap-2.5', iconBox: 'w-10 h-10' },
    lg: { icon: 'text-3xl', steel: 'text-3xl', link: 'text-3xl', global: 'text-sm', gap: 'gap-3', iconBox: 'w-12 h-12' },
  };
  const s = sizes[size];

  const steelColor = variant === 'light' ? '#ffffff' : '#0a2342';
  const linkColor = variant === 'light' ? '#7eb8f7' : '#1e5fa8';
  const globalColor = variant === 'light' ? 'rgba(255,255,255,0.65)' : '#64748b';
  const iconBg = variant === 'light' ? 'rgba(255,255,255,0.15)' : '#0a2342';
  const iconColor = variant === 'light' ? '#ffffff' : '#ffffff';

  return (
    <div className={`flex items-center ${s.gap}`}>
      {/* Icon mark */}
      <div
        className={`${s.iconBox} flex items-center justify-center rounded-lg flex-shrink-0`}
        style={{ backgroundColor: iconBg }}
      >
        <i className={`ri-building-4-line ${s.icon}`} style={{ color: iconColor }} />
      </div>

      {/* Wordmark */}
      <div className="flex flex-col leading-none">
        <div className="flex items-baseline gap-0">
          <span className={`font-black ${s.steel} tracking-tight`} style={{ color: steelColor }}>
            STEEL
          </span>
          <span className={`font-black ${s.link} tracking-tight`} style={{ color: linkColor }}>
            LINK
          </span>
        </div>
        <span
          className={`font-bold ${s.global} tracking-[0.2em] uppercase mt-0.5`}
          style={{ color: globalColor }}
        >
          GLOBAL
        </span>
      </div>
    </div>
  );
}
